<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="900px"
    @keydown.enter="onEnter"
    content-class=""
  >
    <v-alert
      color="#212121"
      border="left"
      class="mb-0"
      dense
      icon="mdi-alert"
      dark
      style="color: #fff; position: sticky; top: 0; z-index: 1; border-radius: 0;"
    >
      As alterações realizadas neste formulário serão aplicadas a
      <b>Todos </b>os produtos selecionados.
    </v-alert>

    <v-card class="shadow-xl pa-0" style="border-radius: 0 0 12px 12px;">
      <v-toolbar
        flat
        dense
        class="px-6 pt-4 pb-4"
        color="white"
        style="border-top-left-radius: 1rem; background: #f9fafb;"
      >
        <div>
          <h2 class="text-h5 font-weight-medium grey--text text--darken-3">
            Atualizar Produtos
          </h2>
          <p class="caption grey--text text--darken-1 mb-0 mt-1">
            {{ productIds.length }} produto{{ pluralS }} selecionado{{
              pluralS
            }}
          </p>
        </div>

        <v-spacer />
        <v-btn
          icon
          @click="close"
          color="grey lighten-2"
          class="rounded-circle"
        >
          <v-icon color="grey darken-2" size="20">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="px-6 py-8">
        <v-container fluid class="pa-0">
          <!-- Relacionamentos -->
          <v-card
            flat
            class="mb-8 pa-6"
            style="background: #fafbfc; border: 1px solid #e2e8f0; border-radius: 8px;"
          >
            <div class="d-flex align-center mb-4">
              <v-icon color="primary" class="mr-3" size="20"
                >mdi-link-variant</v-icon
              >
              <h3
                class="text-h6 font-weight-medium grey--text text--darken-2 mb-0"
              >
                Relacionamentos
              </h3>
            </div>

            <v-row class="ma-0">
              <v-col cols="12" md="4" class="pa-2">
                <CategoriesSearch
                  v-model="request.category"
                  @clear="request.category = null"
                  placeholder="Selecione Categoria"
                />
              </v-col>

              <v-col cols="12" md="4" class="pa-2">
                <BrandsSearch
                  v-model="request.brand"
                  @clear="request.brand = null"
                  placeholder="Selecione Marca"
                />
              </v-col>

              <v-col cols="12" md="4" class="pa-2">
                <SupplierSearch
                  v-model="request.supplier"
                  @clear="request.supplier = null"
                  placeholder="Selecione Fornecedor"
                />
              </v-col>
            </v-row>
          </v-card>

          <!-- Aumentar Preço -->
          <v-card
            flat
            class="mb-8 pa-6"
            style="background: #fafbfc; border: 1px solid #e2e8f0; border-radius: 8px;"
          >
            <div class="d-flex align-center mb-4">
              <v-icon color="primary" class="mr-3" size="20">mdi-trending-up</v-icon>
              <h3 class="text-h6 font-weight-medium grey--text text--darken-2 mb-0">
                Aumentar Preço
              </h3>
            </div>

            <v-row class="ma-0" align="start">
              <v-col cols="12" class="pa-2">
                <v-checkbox
                  v-model="willUpdate.price_increase_percent"
                  hide-details
                  color="primary"
                  class="mt-0 mb-3"
                >
                  <template v-slot:label>
                    <span class="font-weight-medium grey--text text--darken-2">
                      Aumentar Preço (máx. 5%)
                    </span>
                  </template>
                </v-checkbox>
                <app-text-field
                  v-model.number="request.price_increase_percent"
                  label="Aumento de Preço % (máx. 5%)"
                  :disabled="!willUpdate.price_increase_percent"
                  placeholder="0.00"
                  type="number"
                  step="0.01"
                  min="0"
                  max="5"
                  dense
                />
                <p class="caption grey--text text--darken-1 mb-2 mt-4">
                  <v-icon size="14" class="mr-1">mdi-information-outline</v-icon>
                  Arredondamento aplicado ao novo preço:
                </p>
                <table class="rounding-table caption">
                  <thead>
                    <tr>
                      <th>Centavos originais</th>
                      <th>Resultado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>.00 → .04</td><td>.00</td></tr>
                    <tr><td>.05 → .24</td><td>.20</td></tr>
                    <tr><td>.25 → .44</td><td>.40</td></tr>
                    <tr><td>.45 → .54</td><td>.50</td></tr>
                    <tr><td>.55 → .64</td><td>.60</td></tr>
                    <tr><td>.65 → .84</td><td>.80</td></tr>
                    <tr><td>.85 → .99</td><td>.90</td></tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-card>

          <!-- Campos Específicos -->
          <v-card
            flat
            class="pa-6"
            style="background: #fafbfc; border: 1px solid #e2e8f0; border-radius: 8px;"
          >
            <div class="d-flex align-center mb-4">
              <v-icon color="primary" class="mr-3" size="20">mdi-tune</v-icon>
              <div>
                <h3
                  class="text-h6 font-weight-medium grey--text text--darken-2 mb-1"
                >
                  Campos Específicos
                </h3>
                <p class="caption grey--text mb-0">
                  Só serão considerados os campos marcados abaixo
                </p>
              </div>
            </div>

            <v-row class="ma-0">
              <!-- Unidade -->
              <v-col cols="12" md="6" class="pa-2">
                <div class="field-group">
                  <v-checkbox
                    v-model="willUpdate.unity_id"
                    hide-details
                    color="primary"
                    class="mt-0 mb-3"
                  >
                    <template v-slot:label>
                      <span
                        class="font-weight-medium grey--text text--darken-2"
                      >
                        Alterar Unidade
                      </span>
                    </template>
                  </v-checkbox>
                  <AppSelectUnities
                    v-model="request.unity_id"
                    placeholder="Selecione Unidade"
                    :disabled="!willUpdate.unity_id"
                    dense
                  />
                </div>
              </v-col>

              <!-- NCM -->
              <v-col cols="12" md="6" class="pa-2">
                <div class="field-group">
                  <v-checkbox
                    v-model="willUpdate.ncm"
                    hide-details
                    color="primary"
                    class="mt-0 mb-3"
                  >
                    <template v-slot:label>
                      <span
                        class="font-weight-medium grey--text text--darken-2"
                      >
                        Alterar NCM
                      </span>
                    </template>
                  </v-checkbox>
                  <app-text-field
                    v-model="formattedNCM"
                    label="NCM"
                    :disabled="!willUpdate.ncm"
                    placeholder="0000.00.00"
                    maxlength="10"
                    dense
                  />
                </div>
              </v-col>

              <!-- CEST -->
              <v-col cols="12" md="6" class="pa-2">
                <div class="field-group">
                  <v-checkbox
                    v-model="willUpdate.cest"
                    hide-details
                    color="primary"
                    class="mt-0 mb-3"
                  >
                    <template v-slot:label>
                      <span
                        class="font-weight-medium grey--text text--darken-2"
                      >
                        Alterar CEST
                      </span>
                    </template>
                  </v-checkbox>
                  <app-text-field
                    v-model="formattedCEST"
                    label="CEST"
                    :disabled="!willUpdate.cest"
                    placeholder="00.000.00"
                    maxlength="9"
                    dense
                  />
                </div>
              </v-col>

              <!-- Peso Bruto -->
              <v-col cols="12" md="6" class="pa-2">
                <div class="field-group">
                  <v-checkbox
                    v-model="willUpdate.weight_gross"
                    hide-details
                    color="primary"
                    class="mt-0 mb-3"
                  >
                    <template v-slot:label>
                      <span
                        class="font-weight-medium grey--text text--darken-2"
                      >
                        Alterar Peso Bruto
                      </span>
                    </template>
                  </v-checkbox>
                  <app-text-field
                    v-model="formattedWeightGross"
                    label="Peso Bruto (kg)"
                    :disabled="!willUpdate.weight_gross"
                    placeholder="0.000"
                    type="number"
                    step="0.001"
                    dense
                  />
                </div>
              </v-col>

              <!-- Peso Líquido -->
              <v-col cols="12" md="6" class="pa-2">
                <div class="field-group">
                  <v-checkbox
                    v-model="willUpdate.weight_net"
                    hide-details
                    color="primary"
                    class="mt-0 mb-3"
                  >
                    <template v-slot:label>
                      <span
                        class="font-weight-medium grey--text text--darken-2"
                      >
                        Alterar Peso Líquido
                      </span>
                    </template>
                  </v-checkbox>
                  <app-text-field
                    v-model="formattedWeightNet"
                    label="Peso Líquido (kg)"
                    :disabled="!willUpdate.weight_net"
                    placeholder="0.000"
                    type="number"
                    step="0.001"
                    dense
                  />
                </div>
              </v-col>

              <!-- Status -->
              <v-col cols="12" md="6" class="pa-2">
                <div class="field-group">
                  <v-checkbox
                    v-model="willUpdate.status"
                    hide-details
                    color="primary"
                    class="mt-0 mb-3"
                  >
                    <template v-slot:label>
                      <span
                        class="font-weight-medium grey--text text--darken-2"
                      >
                        Alterar Status
                      </span>
                    </template>
                  </v-checkbox>
                  <v-chip-group v-model="request.status" class="mt-2">
                    <v-chip
                      filter
                      :value="1"
                      color="primary"
                      :disabled="!willUpdate.status"
                      class="font-weight-medium"
                    >
                      Ativo
                    </v-chip>
                    <v-chip
                      filter
                      :value="0"
                      :disabled="!willUpdate.status"
                      color="grey"
                      class="font-weight-medium"
                    >
                      Inativo
                    </v-chip>
                  </v-chip-group>
                </div>
              </v-col>
            </v-row>

          </v-card>
        </v-container>
      </v-card-text>

      <v-divider />
      <v-card-actions class="justify-end px-6 py-4" style="background:#fff;">
        <v-btn
          text
          color="grey darken-1"
          @click="close"
          class="font-weight-medium px-6"
          style="text-transform: none;"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          elevation="2"
          class="ml-4 px-8 font-weight-medium"
          :loading="loading"
          @click="handleConfirm"
          style="text-transform: none; border-radius: 6px;"
        >
          <v-icon small left>mdi-check</v-icon>
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BrandsSearch from "@/components/brands/ui/BrandsSearch.vue";
import SupplierSearch from "@/components/suppliers/ui/SupplierSearch.vue";
import AppSelectUnities from "@/components/app/sections/AppSelectUnities.vue";
import CategoriesSearch from "@/components/categories/ui/CategoriesSearch.vue";
import { useNcmCest } from "@/composables/useNcmCest.js";

const { formatNCM, unformatNCM, formatCEST, unformatCEST } = useNcmCest();

export default {
  components: {
    BrandsSearch,
    SupplierSearch,
    AppSelectUnities,
    CategoriesSearch,
  },
  props: {
    value: { type: Boolean, required: true },
    productIds: { type: Array, required: true },
  },
  data() {
    return {
      loading: false,

      relationFields: ["category", "brand", "supplier"],

      updatableFields: ["ncm", "cest", "status"],

      request: {
        ncm: null,
        cest: null,
        brand: null,
        status: null,
        category: null,
        supplier: null,
        unity_id: null,
        weight_net: null,
        weight_gross: null,
        price_increase_percent: null,
      },

      willUpdate: {
        ncm: false,
        cest: false,
        status: false,
        unity_id: false,
        weight_net: false,
        weight_gross: false,
        price_increase_percent: false,
      },
    };
  },

  computed: {
    pluralS() {
      return this.productIds.length > 1 ? "s" : "";
    },

    formattedNCM: {
      get() {
        return formatNCM(this.request.ncm);
      },
      set(value) {
        this.request.ncm = unformatNCM(value);
      },
    },

    formattedCEST: {
      get() {
        return formatCEST(this.request.cest);
      },
      set(value) {
        this.request.cest = unformatCEST(value);
      },
    },

    formattedWeightGross: {
      get() {
        return this.request.weight_gross;
      },
      set(value) {
        this.request.weight_gross = value;
      },
    },

    formattedWeightNet: {
      get() {
        return this.request.weight_net;
      },
      set(value) {
        this.request.weight_net = value;
      },
    },
  },

  methods: {
    resetFields() {
      Object.keys(this.request).forEach((key) => {
        this.request[key] = null;
      });

      Object.keys(this.willUpdate).forEach((key) => {
        this.willUpdate[key] = false;
      });

      this.request.unity_id = null;
    },

    close() {
      this.$emit("input", false);
      this.request = { category: null, brand: null };
      this.resetFields();
    },

    async handleConfirm() {
      this.loading = true;

      const payload = {
        product_ids: this.productIds,
        unity_id: this.willUpdate.unity_id ? this.request.unity_id?.id : null,
        weight_gross: this.willUpdate.weight_gross
          ? this.request.weight_gross
          : null,
        weight_net: this.willUpdate.weight_net ? this.request.weight_net : null,
        price_increase_percent: this.willUpdate.price_increase_percent
          ? this.request.price_increase_percent
          : null,
      };

      this.relationFields.forEach((field) => {
        payload[`${field}_id`] = this.request[field]?.id ?? null;
      });

      this.updatableFields.forEach((field) => {
        payload[field] = this.willUpdate[field] ? this.request[field] : null;
      });

      try {
        await this.$http.store("product/mass-update-product-form", payload);
        this.close();
        this.$emit("updated");
      } catch (error) {
        console.error("Error updating productIds:", error);
      } finally {
        this.loading = false;
        this.resetFields();
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.field-group {
  min-height: 100px;
}

.rounding-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.rounding-table th,
.rounding-table td {
  border: 1px solid #e2e8f0;
  padding: 4px 10px;
  text-align: center;
}

.rounding-table thead tr {
  background: #f1f5f9;
  font-weight: 600;
  color: #475569;
}

.rounding-table tbody tr:nth-child(even) {
  background: #f8fafc;
}

.rounding-table tbody td:last-child {
  font-weight: 600;
  color: #1e40af;
}
</style>
